import { client } from '../common/client';
import type {
  GetOrderRequest,
  GetOrderResponse,
  GetOrdersRequest,
  GetOrdersResponse,
  GetUserOrdersRequest,
  GetUserOrdersResponse,
} from './utils/types';

/**
 * API client for Order-related operations
 */
class OrderAPIClient {
  /**
   * Get a single order by ID
   * @param params - Order request parameters
   * @returns Promise with order data
   */
  public async getOrder({ orderId, ...params }: GetOrderRequest): Promise<GetOrderResponse> {
    return await client.get(`/orders/${orderId}`, { params }).then((res) => res.data);
  }

  /**
   * Get list of orders
   * @param params - Orders list request parameters
   * @returns Promise with orders list
   */
  public async getOrders(params?: GetOrdersRequest): Promise<GetOrdersResponse> {
    return await client.get('/orders', { params }).then((res) => res.data);
  }

  /**
   * Get orders for a specific user
   * @param params - User orders request parameters
   * @returns Promise with user's orders list
   */
  public async getUserOrders({ userId, ...params }: GetUserOrdersRequest): Promise<GetUserOrdersResponse> {
    return await client.get(`/orders/user/${userId}`, { params }).then((res) => res.data);
  }
}

export const orderAPIClient = new OrderAPIClient();

